var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "px-0": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md12: "" } },
        [
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.profileAddSignature } },
            [
              _c(
                "v-flex",
                { attrs: { "mb-3": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        position: "absolute",
                        right: "20px",
                        display: "inline",
                        "z-index": "2"
                      }
                    },
                    [
                      !_vm.dtCurrentSignature
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mx-1",
                              attrs: {
                                flat: "",
                                outline: "",
                                color: "primary",
                                small: "",
                                round: "",
                                icon: ""
                              },
                              on: { click: _vm.handleUndo }
                            },
                            [_c("v-icon", [_vm._v("undo")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-0",
                          attrs: {
                            flat: "",
                            outline: "",
                            color: "primary",
                            small: "",
                            round: "",
                            icon: ""
                          },
                          on: { click: _vm.handleClearSignature }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        border: "1px solid #DCDCDC",
                        "border-radius": "20px"
                      }
                    },
                    [
                      _vm.dtCurrentSignature
                        ? _c("img", {
                            staticStyle: { width: "100%" },
                            attrs: { src: _vm.signature }
                          })
                        : _c("VueSignaturePad", {
                            ref: "signaturePad",
                            attrs: {
                              height: "40vh",
                              options: { onEnd: _vm.onEnd }
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1ac2572", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1ac2572","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/profile-signature-modal-vertical/template.html
// module id = null
// module chunks = 